import { Component, OnInit, Input } from '@angular/core';
import {Breakdown} from '../../../../model/quote/breakdown/breakdown.model';
import { BreakdownService } from '../../breakdown.service';

@Component({
  selector: 'app-breakdown-full-details',
  templateUrl: './breakdown-full-details.component.html',
  styleUrls: ['./breakdown-full-details.component.css', '../../../quote.component.css']
})
export class BreakdownFullDetailsComponent {
  public quote;
  public quoteApplicationData = new Breakdown();
  public CoverTo;
  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;
      this.quoteApplicationData = value.application;
      this.getVehicleOptions();
    }
  }

  constructor(
    private breakdownService: BreakdownService
  ) { }

  /**
   * Get vehicle weight and year options to calculate premiums 
   */
  public getVehicleOptions(){
    this.breakdownService
      .getHorseboxOptions()
      .subscribe((response: any) => { 
        const options = response.result;
        const vehicle = this.quote.vehicles[0];

        if(vehicle && options) {
          const vehicleOption = options.find((option) => { if(option.id === vehicle.vehicle_hb_weight_id) { return option } });

          if(vehicleOption.label.includes('Over 7.5T.')) {
            this.quote.vehicles[0].weight = 'Over 7.5T.';
          } else {
            this.quote.vehicles[0].weight ='Up to 7.5T.';
          }
        }
      })
  }
}
